import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-024bae5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<ol class=\"breadcrumb page-breadcrumb\" data-v-024bae5b><li class=\"breadcrumb-item\" data-v-024bae5b><a href=\"javascript:void(0);\" data-v-024bae5b>SmartAdmin</a></li><li class=\"breadcrumb-item\" data-v-024bae5b>Category</li><li class=\"breadcrumb-item\" data-v-024bae5b>Sub-category</li><li class=\"breadcrumb-item active\" data-v-024bae5b>Page Title</li><li class=\"position-absolute pos-top pos-right d-none d-sm-block\" data-v-024bae5b><span class=\"js-get-date\" data-v-024bae5b></span></li></ol><div class=\"subheader\" data-v-024bae5b><h1 class=\"subheader-title\" data-v-024bae5b> Teble4goodtable <span class=\"fw-300\" data-v-024bae5b>サンプル</span><sup class=\"badge badge-primary fw-500\" data-v-024bae5b>STICKER</sup><small data-v-024bae5b> Insert page description or punch line </small></h1><div class=\"subheader-block\" data-v-024bae5b>Right Subheader Block</div></div><div class=\"alert alert-primary\" data-v-024bae5b><div class=\"d-flex flex-start w-100\" data-v-024bae5b><div class=\"mr-2 hidden-md-down\" data-v-024bae5b><span class=\"icon-stack icon-stack-lg\" data-v-024bae5b><i class=\"base base-6 icon-stack-3x opacity-100 color-primary-500\" data-v-024bae5b></i><i class=\"base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical\" data-v-024bae5b></i><i class=\"ni ni-blog-read icon-stack-1x opacity-100 color-white\" data-v-024bae5b></i></span></div><div class=\"d-flex flex-fill\" data-v-024bae5b><div class=\"flex-fill\" data-v-024bae5b><span class=\"h5\" data-v-024bae5b>注意事項!</span><p data-v-024bae5b>特に注意事項はないです</p><p class=\"m-0\" data-v-024bae5b> Follow a slogal with a useful link or call to action <a href=\"#\" target=\"_blank\" data-v-024bae5b>Call to action &gt;&gt;</a></p></div></div></div></div>", 3)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = {
  id: "panel-x",
  class: "panel"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"panel-hdr\" data-v-024bae5b><h2 data-v-024bae5b>good table</h2><div class=\"panel-toolbar\" data-v-024bae5b><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\" data-v-024bae5b></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\" data-v-024bae5b></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-close\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Close\" data-v-024bae5b></button></div></div>", 1)
const _hoisted_9 = { class: "panel-container show" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_11 = { class: "panel-content" }
const _hoisted_12 = { class: "frame-wrap" }
const _hoisted_13 = { class: "demo" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-tag" }, " APIを使用したバックエンドの通信も含みます ", -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = {
  key: 0,
  class: "gtablecell"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  type: "button",
  class: "btn btn-xs btn-success waves-effect waves-themed"
}
const _hoisted_19 = {
  key: 1,
  class: "gtablecell"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_good_table = _resolveComponent("vue-good-table")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateTable(1))),
                      id: "btn2",
                      class: "btn btn-primary waves-effect waves-themed"
                    }, " 更新 ")
                  ]),
                  _createVNode(_component_vue_good_table, {
                    mode: "remote",
                    onPageChange: _ctx.onPageChange,
                    onSortChange: _ctx.onSortChange,
                    columns: _ctx.columns,
                    rows: _ctx.rows,
                    "pagination-options": {
                      perPageDropdownEnabled: false,
                      enabled: true,
                      jumpFirstOrLast: true,
                      page: 1,
                      perPage: 10,
                      nextLabel: '次へ',
                      prevLabel: '前へ',
                      mode: 'pages',
                      ofLabel: '～',
                      pageLabel: '',
                    },
                    totalRows: _ctx.totalRecords,
                    styleClass: "vgt-table striped condensed",
                    "fixed-header": true,
                    compactMode: ""
                  }, {
                    "table-row": _withCtx((props) => [
                      (props.column.field == 'c_series_code')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("a", {
                              href: `https://tsugiitsu.com/series/${props.row.c_series_code}/`,
                              target: "_blank"
                            }, [
                              _createElementVNode("button", _hoisted_18, _toDisplayString(props.row.c_series_code), 1)
                            ], 8, _hoisted_17)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(props.formattedRow[props.column.field]), 1))
                    ]),
                    _: 1
                  }, 8, ["onPageChange", "onSortChange", "columns", "rows", "totalRows"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}